// /src/toolkitServices/designApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const designApi = createApi({
  reducerPath: "designApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL, // e.g. http://localhost:4000/api
    credentials: "include",
  }),
  tagTypes: ["Design"],
  endpoints: (builder) => ({
    // CREATE  POST /api/designs/create
    addDesign: builder.mutation({
      query: (payload) => ({
        url: "/designs/create",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Design"],
    }),

    // LIST    GET /api/designs?page=&limit=&q=&active=&category=&product=
    getAllDesigns: builder.query({
      query: ({ page = 1, limit = 1000, search = "", active, category, product } = {}) => {
        const params = { page, limit, q: search };
        if (typeof active === "boolean") params.active = active; // true/false
        if (category) params.category = category;               // id or name
        if (product) params.product = product;                  // id or name
        return { url: "/designs", params };
      },
      providesTags: ["Design"],
    }),

    // GET ONE GET /api/designs/:id
    getDesignById: builder.query({
      query: (id) => `/designs/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Design", id }],
    }),

    // UPDATE  PUT /api/designs/:id
    updateDesign: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/designs/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Design"],
    }),

    // DELETE  DELETE /api/designs/:id
    deleteDesign: builder.mutation({
      query: (id) => ({
        url: `/designs/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Design"],
    }),

    // ACTIVATE / DEACTIVATE
    activateDesign: builder.mutation({
      query: (id) => ({
        url: `/designs/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Design"],
    }),
    deactivateDesign: builder.mutation({
      query: (id) => ({
        url: `/designs/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Design"],
    }),
  }),
});

export const {
  useAddDesignMutation,
  useGetAllDesignsQuery,
  useGetDesignByIdQuery,
  useUpdateDesignMutation,
  useDeleteDesignMutation,
  useActivateDesignMutation,
  useDeactivateDesignMutation,
} = designApi;

export default designApi;
